<template>
  <form @submit.prevent="handleMetaTagSubmission()" method="POST" novalidate>
    <div class="row">
      <div class="col-8">
        <div class="form-group required">
          <label class="control-label" for="meta_title">Meta title</label>
          <input
            type="text"
            id="meta_title"
            name="meta_title"
            v-model="meta.meta_title"
            v-validate="'required'"
            class="form-control"
            placeholder="meta title"
          />
          <div class="help text-danger" v-show="errors.has('meta_title')">
            {{ errors.first("meta_title") }}
          </div>
        </div>
        <div class="form-group required">
          <label class="control-label" for="meta_keywords">Meta keywords</label>
          <input
            type="text"
            id="meta_keywords"
            name="meta_keywords"
            v-model="meta.meta_keywords"
            v-validate="'required'"
            class="form-control"
            placeholder="meta keywords"
          />
          <div class="help text-danger" v-show="errors.has('meta_keywords')">
            {{ errors.first("meta_keywords") }}
          </div>
        </div>
        <div class="form-group required">
          <label class="control-label" for="meta_description"
            >Meta description</label
          >
          <textarea
            id="meta_description"
            name="meta_description"
            v-model="meta.meta_description"
            v-bind:class="{ 'has-error': errors.has('meta_description') }"
            class="form-control"
            placeholder="Description"
            v-validate="'required'"
            rows="3"
          ></textarea>
          <div class="help text-danger" v-show="errors.has('meta_description')">
            {{ errors.first("meta_description") }}
          </div>
        </div>
        <div class="form-group required">
          <label for="meta_image" class="control-label">Thumbnail</label>
          <div class="row align-items-center">
            <div class="col-4">
              <div class="input-group">
                <div class="custom-file">
                  <input
                    type="file"
                    name="meta_image"
                    class="custom-file-input"
                    id="meta_image"
                    @change="selectFile"
                    accept="image/png, image/jpeg, image/jpg"
                  />
                  <label class="custom-file-label" for="meta_image">
                    {{ meta_image_name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-8">
              <img
                alt="preview"
                v-if="temp_thumbnail"
                v-bind:src="temp_thumbnail"
                width="100"
                height="100"
                class="img-thumbnail"
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { CategoryAPI } from "@/services/api";

export default {
  name: "CategorySEOMeta",
  props: {
    meta: Object,
  },
  watch: {
    meta: function (newVal, oldVal) {
      // watch it
      let asset_get_url = this.API_ASSET_UPLOAD_URL + "/";
      this.temp_thumbnail = asset_get_url + this.meta.meta_image;
      this.meta.meta_image = "";
    },
  },
  data: () => ({
    temp_thumbnail: "",
    meta_image_name: "",
  }),
  methods: {
    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.temp_thumbnail = reader.result;
        this.meta.meta_image = reader.result;

        this.$set(this, "meta_image_name", event.target.files[0].name);
      };
    },
    handleMetaTagSubmission() {
      let _this = this;
      CategoryAPI.metaSync(_this.meta)
        .then((response) => {
          _this.$toaster.success(response.message);
          _this.$router.push({ name: "Categories" });
        })
        .catch((err) => {
          _this.$toaster.error(err.data.message);
          if (err.data.errors.code === 424) {
            _this.$toaster.error(err.data.errors.message);
          } else {
            _this.$setErrorsFromResponse(err.data);
          }
        });
    },
  },
};
</script>
